export class RequisitionsQueryFilter {
  companyId: number;
  clientOrBU: any[] = [];
  roleList: any[] = [];
  requisitionNums: any[] = [];
  recruiters: any[] = [];
  requisitionTypes: any[] = [];
  jobTypes: any[] = [];
  workLocationIds: any[] = [];
  requisitionStates: any[] = [];
  searchCheck = false;
  searchText = '';
  size = 9;
  pageNum = 1;
  fromDate = '';
  toDate = '';
  sortColumn = '';
  sortDirection = '';
  isAssignedToMe = true;
  isAssignedToOthers = true;
  isUnassigned = true;
  isAllRequisition = true;
  isSharedWithMe = true;

  constructor(companyId: number) {
    this.companyId = companyId;
  }
}
